import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "no_data" };
export default /*@__PURE__*/ _defineComponent({
    __name: 'UNoData',
    props: {
        text: {
            type: String,
            default: "No Data"
        }
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("span", null, _toDisplayString(__props.text), 1)
            ]));
        };
    }
});
